import { debounce } from '@mui/material';
import { EntityBase } from '@provision/entity-types';
import { MouseEvent, useMemo } from 'react';

const RECORD_CLICK_DEBOUNCE_MS = 300;

export type RecordClickHandler<T extends EntityBase> = (
  id: T['id'],
  record: T,
  event?: MouseEvent,
) => void;

export const useDebouncedRecordClick = <T extends EntityBase>(
  onClick?: RecordClickHandler<T>,
) =>
  useMemo(
    () =>
      debounce((id: T['id'], record: T, event?: MouseEvent) => {
        onClick?.(id, record, event);
      }, RECORD_CLICK_DEBOUNCE_MS),
    [onClick],
  );
